import {FC} from 'react';
//mui
import {Box, Link, Typography} from '@mui/material';
//enums
import {ROUTER_URL} from '@/utils/enums';
//constants
import {BODY1, LOG_IN} from '@/utils/constants';
//components
import FormContent from './FormContent';
import SocialFormActions from '../../../SocialFormActions';
import HeaderForm from '../../../HeaderForm';
//styles
import {signUpFormContentStyle} from './SignUpFormContent.styles';
import {IAuthAppleRequest} from '@/utils/types';

interface SignUpFormContentProps {
	socialProvider?: 'Google' | 'Apple';
	socialEmail?: string;
	onGoogleSignupSuccess: (idToken: string) => void;
	onAppleSignupSuccess: (request: IAuthAppleRequest) => Promise<void>;
	onResetSocialSignup: () => void;
}

const SignUpFormContent: FC<SignUpFormContentProps> = ({
	socialProvider,
	socialEmail,
	onGoogleSignupSuccess,
	onAppleSignupSuccess,
	onResetSocialSignup,
}) => {
	return (
		<Box sx={signUpFormContentStyle.wrapper}>
			<HeaderForm title="Organization Details" sx={signUpFormContentStyle.header} />

			<FormContent socialProvider={socialProvider} socialEmail={socialEmail} />

			{socialProvider ? (
				// eslint-disable-next-line jsx-a11y/anchor-is-valid
				<Link component="button" type="button" onClick={onResetSocialSignup}>
					Use a different account
				</Link>
			) : (
				<SocialFormActions
					onGoogleSignupSuccess={onGoogleSignupSuccess}
					onAppleSignupSuccess={onAppleSignupSuccess}
				/>
			)}

			<Typography sx={signUpFormContentStyle.logIn} variant={BODY1}>
				Already have an account?
				<Link href={ROUTER_URL.LOGIN} sx={signUpFormContentStyle.link}>
					{LOG_IN}
				</Link>
			</Typography>
		</Box>
	);
};

export default SignUpFormContent;
